// removed by extract-text-webpack-plugin
module.exports = {"visible-xs":"visible-xs___20OhH","visible-sm":"visible-sm___2EAU8","visible-md":"visible-md___2XLec","visible-lg":"visible-lg___1UtI_","row":"row___2h2Zm","hidden-xs":"hidden-xs___2d3AI","hidden-sm":"hidden-sm___2L7s_","hidden-md":"hidden-md___1nmBC","hidden-lg":"hidden-lg___1-o01","form-wrap":"form-wrap___NKYIf","form":"form___15Ul6","input":"input___2Jlus input___1Bv7m h3___5u0xZ","submit":"submit___3odFz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PetitionForm/PetitionForm.css
// module id = 894
// module chunks = 0